import {Injectable} from '@angular/core'; 
import { Meta, Title } from '@angular/platform-browser';

@Injectable()
export class SEOService {
  constructor(private title: Title, private meta: Meta) { }


  updateTitle(title: string) {
    // console.log("title"+title)
    this.title.setTitle(title);
  }

  updateDescription(desc: string) {
    // console.log("desc"+desc)
    this.meta.updateTag({ name: 'description', property: 'description',  content: desc })
  }

  updateKeywords(keywords: string) {
    // console.log("keywords"+keywords)
    this.meta.updateTag({ name: 'keywords', content: keywords })
  }

  updateOgTitle(title: string){
    this.meta.updateTag({ name: 'og:title', property: 'og:title', content: title });
    this.meta.getTags("name='og:title'")[1].setAttribute("content", title);
  }

  updateOgDescription(desc: string){
    this.meta.updateTag({ name: 'og:description', property: 'og:description', content: desc });
    this.meta.getTags("name='og:description'")[1].setAttribute("content", desc);
  }

  updateOgUrl(url: string){
    this.meta.updateTag({ name: 'og:url', property: 'og:url', content: url });
    this.meta.getTags("name='og:url'")[1].setAttribute("content", url);
  }

  updateOgType(type: string){
    this.meta.updateTag({ name: 'og:type', property: 'og:type', content: type });
    this.meta.getTags("name='og:type'")[1].setAttribute("content", type);
  }

  updateOgImage(image: string){
    this.meta.updateTag({ name: 'og:image', property: 'og:image', content: image });
    this.meta.getTags("name='og:image'")[1].setAttribute("content", image);
  }

  updateOgSiteName(name: string){
    this.meta.updateTag({ name: 'og:site_name', property: 'og:site_name', content: name });
  }

  updateTwitterCard(card: string){
    this.meta.updateTag({ name: 'twitter:card', property: 'twitter:card', content: card });
  }

  updateTwitterUrl(url: string){
    this.meta.updateTag({ name: 'twitter:url', property: 'twitter:url', content: url });
  }

  updateTwitterTitle(title: string){
    this.meta.updateTag({ name: 'twitter:title', property: 'twitter:title', content: title });
  }

  updateTwitterDesc(desc: string){
    this.meta.updateTag({ name: 'twitter:description', property: 'twitter:description', content: desc });
  }

  updateTwitterImage(image: string){
    this.meta.updateTag({ name: 'twitter:image', property: 'twitter:image', content: image });
  }
}  